// src/components/common/TimeBoxPattern.tsx
import React from 'react';
import { TimeBoxCategory } from '../../types/timeBox';
import { EventCategory } from '../../types/calendar-event';
// 從 Lucide 引入適合各類別的圖標
import { 
    Zap,         // focus
    RotateCcw,   // routine
    Heart,       // life
    Coffee,      // rest
    Clock,       // empty
    // Event 圖標
    Calendar,    // appointment
    Users,       // meeting
    GraduationCap, // class
    AlertCircle, // deadline
    Crown,       // ceremony
    Gift,        // anniversary
    Sun,         // holiday
    Trophy,      // competition
    Info         // other
} from 'lucide-react';

interface TimeBoxPatternProps {
  category?: TimeBoxCategory | EventCategory | 'empty';
  className?: string;
  opacity?: number;
}

const TimeBoxPattern: React.FC<TimeBoxPatternProps> = ({ 
  category = 'empty', 
  className = '',
  opacity = 0.09
}) => {
  // 根據類別選擇合適的圖標和顏色
  const getPatternIcon = () => {
    switch(category) {
      // TimeBox 類別 - 統一使用藍色，僅靠圖形區分類別
      case 'focus':
        return <Zap className="text-sky-400" size={130} />;
      case 'routine':
        return <RotateCcw className="text-sky-400" size={130} />;
      case 'life':
        return <Heart className="text-sky-400" size={130} />;
      case 'rest':
        return <Coffee className="text-sky-400" size={130} />;
      
      // Event 類別 - 使用深 amber 色以在淺色背景上顯現
      case 'meeting':
        return <Users className="text-amber-500" size={130} />;
      case 'appointment':
        return <Calendar className="text-amber-500" size={130} />;
      case 'class':
        return <GraduationCap className="text-amber-500" size={130} />;
      case 'social':
        return <Heart className="text-amber-500" size={130} />;
      case 'deadline':
        return <AlertCircle className="text-amber-500" size={130} />;
      case 'ceremony':
        return <Crown className="text-amber-500" size={130} />;
      case 'anniversary':
        return <Gift className="text-amber-500" size={130} />;
      case 'holiday':
        return <Sun className="text-amber-500" size={130} />;
      case 'competition':
        return <Trophy className="text-amber-500" size={130} />;
      case 'other':
        return <Info className="text-amber-500" size={130} />;
      
      case 'empty':
      default:
        return <Clock className="text-gray-300" size={130} />;
    }
  };
  
  // 計算樣式
  const opacityStyle = { opacity: opacity };
  
  return (
    <div className={`absolute inset-0 z-0 pointer-events-none overflow-hidden ${className}`}>
      <div 
        className="absolute -bottom-6 -right-6 transform rotate-12"
        style={opacityStyle}
      >
        {getPatternIcon()}
      </div>
    </div>
  );
};

export default TimeBoxPattern;